jQuery( document ).ready(function() {

    // Initialize Tiny Slider
    jQuery(".tiny-slider.tiny-slider-testimonials").each(function() {
        var sliderId = jQuery(this).data('slider');
        var currentSlider = jQuery('.tiny-slider.tiny-slider-testimonials.'+sliderId).parents('.testimonials-container');
        var photoGallerySlider = tns({
            container: '.tiny-slider.tiny-slider-testimonials.'+sliderId,
            items: 1,
            slideBy: 'page',
            autoplay: false,
            mouseDrag: true,
            controls: false,
            nav: false
        });

        // Navigation
        photoGallerySlider.events.on('transitionEnd', function (data) {
            // Current slide - text
            currentSlider.find('.photo-gallery-navigation .current-no').text(data.displayIndex);
        });

        // Controls
        currentSlider.find('.photo-gallery-navigation').on('click', '.prev', function () {
            photoGallerySlider.goTo('prev');
        });
        currentSlider.find('.photo-gallery-navigation').on('click', '.next', function () {
            photoGallerySlider.goTo('next');
        });
    });
});